module.exports = __webpack_public_path__ + "img/check-circle-2.8ad395b9.svg";